import { initSlider } from './splidecust';

const elemSplide = document.querySelector('.hero__splide');
if (elemSplide) {
  initSlider(elemSplide, {
    pagination: true,
    autoplay: true,
    interval: 3000,
    type: 'loop',
    gap: '3.75rem',
    perPage: 1,
  });
}

const recSplideAll = document.querySelectorAll('.recomends__splide');
recSplideAll?.forEach(recSplide => {
  let count = 4;
  let dis = false;

  if(recSplide.classList.contains('three')) {
    count = 3;
  }


  if(recSplide.classList.contains('disMob')) {
    dis = true;
  }

  if (recSplide) {
    initSlider(recSplide, {
      type: 'loop',
      perPage: count,
      gap: '1.38rem',
      arrows: true,
      lazyLoad: 'nearby',
      breakpoints: {
        960: {
          perPage: 3,
          gap: '1.31rem',
          arrows: false,
        },
        768: {
          perPage: 2,
          destroy: dis,
        },
        480: {
          perPage: 1,
        },
      },
    });
  }
});

const asideSplide = document.querySelector('.aside__splide');
if (asideSplide) {
  initSlider(asideSplide, {
    type: 'loop',
    perPage: 4,
    gap: '1.38rem',
    arrows: true,
    destroy: true,
    breakpoints: {
      960: {
        perPage: 3,
        gap: '1.31rem',
        arrows: false,
        destroy: false,
      },
      768: {
        perPage: 2,
        destroy: false,
      },
      480: {
        perPage: 1,
        destroy: false,
      },
    },
  });
}

const photoSplide = document.querySelector('.photo-slider__splide');
if (photoSplide) {
  initSlider(photoSplide, {
    type: 'loop',
    perPage: 5,
    gap: '.625rem',
    arrows: true,
    breakpoints: {
      960: {
        perPage: 3,
        arrows: false,
        destroy: false,
      },
      768: {
        perPage: 2,
        destroy: false,
      },
      480: {
        perPage: 1,
        destroy: false,
        gap: '1.25rem',
      },
    },
  });
}

// const destroySliders = () => {
//   if (elemSliderInstance) {
//     elemSliderInstance.destroy();
//     elemSliderInstance = null;
//   }
// };

// const checkViewport = () => {
//   elemInitSlider();
//   if (window.innerWidth > 960) {
//     destroySliders();
//   }
// };

// window.addEventListener('resize', checkViewport);
// document.addEventListener('DOMContentLoaded', checkViewport);
